/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, metric: NonNullable<unknown> }} Perks_Head_StatInputs */



/**
* | output |
* | --- |
* | "{min} {metric}" |
*
* @param {Perks_Head_StatInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_head_stat = /** @type {((inputs: Perks_Head_StatInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Head_StatInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric}`)
	return /** @type {LocalizedString} */ (`${i?.min} ${i?.metric}`)
});